// extracted by mini-css-extract-plugin
export default {"submit_button":"button_submit_button__F38Mf","valid":"button_valid__Z2kMD","invalid":"button_invalid__UFtM8"};